export const environment = {
    s3        : 'https://striive-public.s3.eu-central-1.amazonaws.com/',
    apiUrl    : 'https://striive-cms.codebridge.nl/api/',
    production: true
};
